import React from 'react';

import { Button } from '@swyftx/aviary/atoms/Button';
import { Input } from '@swyftx/aviary/atoms/Input';
import { Body } from '@swyftx/aviary/atoms/Typography';

import AssetIcon from '@global-components/AssetIcon/AssetIcon';

import { Asset } from '@shared/api';

import { useFormatInputText } from 'src/lib/utils/hooks/useFormatInputText';

type Props = {
  onChange: (value: string) => void;
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
  asset?: Asset;
  placeholder?: string;
  value: string;
  errorMessage?: string;
  forceSuffix?: string;
  onMax: () => void;
};

const FiatInput: React.FC<Props> = ({
  asset,
  placeholder,
  leading,
  trailing,
  value,
  onChange,
  errorMessage,
  onMax,
}) => {
  const { formattedAmount, onChangeValue } = useFormatInputText({
    asset,
    onChange,
    value,
    ignoreAssetScale: false,
    blockAlphaNumericChars: true,
    maxDecimal: 2,
  });

  return (
    <>
      <Input
        id='crypto-loan-fiat-input'
        appearance='outlined'
        value={formattedAmount}
        error={!!errorMessage}
        placeholder={placeholder}
        onChange={onChangeValue}
        autoComplete='off'
        leading={
          leading ? (
            leading
          ) : (
            <Body>
              <AssetIcon asset={asset} size={20} />
            </Body>
          )
        }
        trailing={
          trailing ? (
            trailing
          ) : (
            <Button variant='outlined' size='sm' onClick={onMax}>
              MAX
            </Button>
          )
        }
      />
      {errorMessage && (
        <Body size='xsmall' color='error'>
          {errorMessage}
        </Body>
      )}
    </>
  );
};

FiatInput.displayName = 'FiatInput';

export { FiatInput };
